import createAxiosInstance from 'src/utils/createAxiosInstance';
import { AUTH_API_URL, CLIENT_PORTAL_API_URL, DATA_GATEWAY_API_URL } from 'src/utils/constants';

export const authApi = createAxiosInstance(AUTH_API_URL);
export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const dataGatewayApi = createAxiosInstance(DATA_GATEWAY_API_URL);
